import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants/style';

export const FLEX_GAP_FOR_SELECTED_CHIPS = 12;
export const MORE_TEXT_MAX_WIDTH = 70;

export const useStyles = makeStyles(theme =>
  createStyles({
    optionRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    option: {
      padding: '10px 15px !important',
      minHeight: '44px !important',
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        lineHeight: '20px !important',
        color: `${STYLE.COLOR.TEXT1} !important`,
      },
    },
    optionLabel: {
      fontSize: '14px !important',
      lineHeight: '20px !important',
    },
    searchbarParent: {
      padding: '10px 15px',
      height: '62px',
    },
    searchInput: {
      '& .MuiInputBase-root': {
        height: '42px !important',
        borderRadius: '8px !important',
        borderWidth: '1px !important',
        borderColor: `${STYLE.COLOR.STROKE_DEFAULT} !important`,
        padding: '12px 14px !important',
      },
      '& .MuiInputBase-input': {
        padding: '0 !important',
        fontSize: '12px !important',
        lineHeight: '18px !important',
        fontWeight: '400 !important',
        fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
      },
      '& .MuiInputBase-input::placeholder': {
        fontSize: '12px !important',
        lineHeight: '18px !important',
        fontWeight: '400 !important',
        fontFamily: `${STYLE.FONT.PRIMARY_FONT} !important`,
        color: `${STYLE.COLOR.TEXT3} !important`,
        opacity: '1 !important',
      },
    },
    label: {
      position: 'absolute',
      transition: 'all 0.2s ease-in',
      opacity: '1 !important',
    },
    labelBig: {
      fontWeight: '400',
      fontSize: `14px`,
      lineHeight: '20px',
      color: STYLE.COLOR.TEXT3,
      top: '50%',
      transform: 'translateY(-50%)',
      left: '8px',
    },
    // labelShrink: {
    //   color: STYLE.COLOR.TEXT2,
    //   backgroundColor: STYLE.COLOR.WHITE,
    //   borderRadius: "12px",
    //   padding: "4px 6px 4px 6px",
    //   fontWeight: "500",
    //   fontSize: `10px`,
    //   lineHeight: "16px",
    //   opacity: "1 !important",
    //   left: 2,
    //   transform: "translateY(-24px)",
    // },
    labelShrink: {
      color: STYLE.COLOR.TEXT2,
      backgroundColor: STYLE.COLOR.WHITE,
      borderRadius: '12px',
      padding: '4px 6px 4px 6px',
      fontWeight: '500',
      fontSize: `10px`,
      lineHeight: '16px',
      opacity: '1 !important',
      left: 20,
      transform: 'translateY(-12px)',
      zIndex: 2,
    },
    labelError: {
      color: `${STYLE.COLOR.ERROR} !important`,
    },
    value: {
      position: 'absolute',
      color: STYLE.COLOR.TEXT1,
      fontSize: `14px`,
      lineHeight: '20px',
      top: '50%',
      transform: 'translateY(-50%)',
      // left: '8px',
    },
    dropdownIcon: {
      transition: 'all 0.2s ease-in',
      // cursor: "pointer",
    },
    dropdownIconRotated: {
      transform: 'rotate(180deg)',
      transition: 'all 0.2s ease-in',
    },
    clearIcon: {
      height: '18px',
      width: '18px',
    },
    requiredMark: {
      color: STYLE.COLOR.ERROR,
      paddingLeft: '3px',
    },
    skippableMark: {
      color: STYLE.COLOR.WARNING,
      paddingLeft: '3px',
    },
    cursorDisabled: {
      cursor: 'not-allowed !important',
    },
    selectAllParent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 15px',
      '& .MuiFormControlLabel-label': {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        lineHeight: '20px !important',
        color: `${STYLE.COLOR.TEXT1} !important`,
      },
    },
    clearAll: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '500',
      fontFamily: STYLE.FONT.PRIMARY_FONT,
      color: STYLE.COLOR.ACCENT_PRIMARY,
      cursor: 'pointer',
      alignSelf: 'center',
      textAlign: 'center',
    },
    selectedChipsContainer: {
      display: 'flex',
      flexWrap: 'nowrap',
      overflow: 'hidden',
      gap: FLEX_GAP_FOR_SELECTED_CHIPS,
      marginTop: '14px',
      minHeight: '32px',
    },
    moreChipsText: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '500',
      color: STYLE.COLOR.ACCENT_PRIMARY,
      alignSelf: 'center',
      cursor: 'pointer',
      textDecoration: 'underline',
    },
    modal: {
      '& .MuiDialog-paper': {
        width: '900px',
        maxWidth: '100%',
      },
    },
    modalButtons: {
      minWidth: '136px !important',
    },
    modalCheckbox: {
      padding: '10px 15px',
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        lineHeight: '20px',
      },
    },
  }),
);
